import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/AcompanhamentoNutricional";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/acompanhamento-nutricional-australia")({
  head: () =>
    pageHead({
      title: "Acompanhamento nutricional na Austrália | Clara Camille",
      description:
        "Acompanhamento nutricional para brasileiros na Austrália. Plano alimentar, suporte por WhatsApp e ajustes contínuos. Consulta inicial gratuita.",
      path: "/acompanhamento-nutricional-australia",
      ogDescription:
        "Plano alimentar personalizado, suporte por WhatsApp e ajustes contínuos para brasileiros na Austrália. Consulta inicial gratuita.",
      jsonLd: [
        breadcrumbJsonLd([{ name: "Acompanhamento nutricional", path: "/acompanhamento-nutricional-australia" }]),
        faqJsonLd(faqItems),
      ],
    }),
  component: Page,
});
